import { reactive } from 'vue';

export const criarDriveGrupo = () => {
  return reactive({
    id: 0,
    idep: 0,
    cddrivegrupo: 0,
    nmdrivegrupo: "",
    obs: "",
    ckativo: "S",
    idlogin: 0
  });
}